import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ocorrencias from "@/pages/Ocorrencias";
import SLA from "@/pages/SLA";
import Inventario from "@/pages/Inventario";
import Enderecos from "@/pages/Enderecos";
import Picklist from "@/pages/Picklist";
import Reposicao from "@/pages/Reposicao";
import Validade13Meses from "@/pages/Validade13Meses";
import Separacao from "@/pages/Separacao";
import Recebimento from "@/pages/Recebimento";
import ConferenciaMercadoria from "@/pages/ConferenciaMercadoria";
import ConferenciaVolumesPage from "@/pages/ConferenciaVolumesPage";
import LocalizadorInteligente from "@/pages/LocalizadorInteligente";
import { ROLE_HOME, ROLE_ALLOWED } from "@/lib/roles";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="app-loading">
        <div className="text-[#5A6B62] text-sm">Carregando ESTOQAR...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const allowed = ROLE_ALLOWED[user.role];
  if (allowed) {
    const p = location.pathname;
    const ok = allowed.some((path) => path === "/" ? p === "/" : (p === path || p.startsWith(path + "/")));
    if (!ok) return <Navigate to={ROLE_HOME[user.role]} replace />;
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/ocorrencias" element={<Protected><Ocorrencias /></Protected>} />
            <Route path="/sla" element={<Protected><SLA /></Protected>} />
            <Route path="/inventario" element={<Protected><Inventario /></Protected>} />
            <Route path="/picklist" element={<Protected><Picklist /></Protected>} />
            <Route path="/reposicao" element={<Protected><Reposicao /></Protected>} />
            <Route path="/separacao" element={<Protected><Separacao /></Protected>} />
            <Route path="/recebimento" element={<Protected><Recebimento /></Protected>} />
            <Route path="/conferencia" element={<Protected><ConferenciaMercadoria /></Protected>} />
            <Route path="/conferencia-volumes" element={<Protected><ConferenciaVolumesPage /></Protected>} />
            <Route path="/enderecos" element={<Protected><Enderecos /></Protected>} />
            <Route path="/validade" element={<Protected><Validade13Meses /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
